export const FileUploadTypes = {
  MINI: 'mini',
  CARD: 'card',
  CUSTOM: 'custom',
  DEFAULT: 'default',
};

export const PFX_MIME_TYPE = 'application/x-pkcs12';
export const MAX_CHAR_COUNT = 255;

export const ErrorCodes = {
  LARGE_FILE_ERROR_CODE: 'file-too-large',
};

export const FileTypes = {
  VIDEO: 'video',
  AUDIO: 'audio',
  IMAGE: 'image',
  APPLICATION: 'application',
};
